export var SELECT = 'select';
export var MULTI_SELECT = 'multiSelect';
export var HIDDEN = 'hidden';